export function isHeadingSegment(
  item?: ProposalSegment | Partial<ProposalSegment & Record<'id', string>>,
): item is HeadingSegment {
  return item?.type === 'heading';
}
